import React from 'react';

const ImageViewerModal = ({ isOpen, onClose, imageUrl, altText }) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div 
            className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
            onClick={handleBackdropClick}
        >
            {/* Image Container with Close Button */}
            <div className="relative w-full max-w-xl sm:max-w-3xl lg:max-w-xl max-h-[80vh] sm:max-h-[85vh]">
                {/* Close Button - positioned relative to image */}
                <button
                    onClick={onClose}
                    className="absolute -top-2 -right-2 text-white hover:text-gray-300 transition-colors z-10 bg-black bg-opacity-50 rounded-full p-1.5 sm:p-2 hover:bg-opacity-75"
                >
                    <svg className="w-4 h-4 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                {/* Image */}
                <img
                    src={imageUrl}
                    alt={altText || 'Full size image'}
                    className="w-full h-auto max-h-full object-contain rounded-lg shadow-2xl"
                    onError={(e) => {
                        e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik02MCAxMDBDNjAgNzcuOTA4NiA3Ny45MDg2IDYwIDEwMCA2MEMxMjIuMDkxIDYwIDE0MCA3Ny45MDg2IDE0MCAxMDBDMTQwIDEyMi4wOTEgMTIyLjA5MSAxNDAgMTAwIDE0MEM3Ny45MDg2IDE0MCA2MCAxMjIuMDkxIDYwIDEwMFoiIGZpbGw9IiNEMUQ1REIiLz4KPHBhdGggZD0iTTEwMCAxMjBDMTEwLjQ1NyAxMjAgMTE5IDExMS40NTcgMTE5IDEwMUMxMTkgOTAuNTQzNCAxMTAuNDU3IDgyIDEwMCA4MkM4OS41NDM0IDgyIDgxIDkwLjU0MzQgODEgMTAxQzgxIDExMS40NTcgODkuNTQzNCAxMjAgMTAwIDEyMFoiIGZpbGw9IiM5Q0EzQUYiLz4KPC9zdmc+';
                    }}
                />
            </div>
        </div>
    );
};

export default ImageViewerModal; 